/** @jsx jsx */
import { jsx, Image, Flex, Container, Box } from "theme-ui";
import { Link as GatsbyLink } from "gatsby";

import PageSection from "./PageSection";
import logo from "../../content/assets/fileside-logo-64.png";
import Nav from "./Nav";

const Header = () => {
  return (
    <PageSection as="header" sx={{bg: "primaryDark", py: [4, 5, 5]}}>
      <Container sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "space-between",

        "@media screen and (min-width: 580px)": {
          flexDirection: "row",
          alignItems: "center",
        }
      }}>
        <GatsbyLink to="/" sx={{textDecoration: "none", "&:focus": { outline: 0 }}}>
          <Flex sx={{
            flexDirection: "row",
            alignItems: "center",
          }}>
            <Image src={logo} sx={{width: 32, mr: 4, mb: "2px"}} />
            <span sx={{variant: "styles.h2", color: "white", m: 0}}>
              Fileside
            </span>
          </Flex>
        </GatsbyLink>

        <Box sx={{
          mt: 3,
          "@media screen and (min-width: 580px)": {
            mt: 0
          },
        }}>
          <Nav orientation="row" />
        </Box>
      </Container>
    </PageSection>
  );
};

export default Header;
